import type {
  GuideTourDefinition,
  GuideTourStep,
  GuideTourStepCardSize,
} from '../types'

export const GUIDE_TOUR_STEP_CARD_WIDTH_BY_SIZE: Record<
  GuideTourStepCardSize,
  number
> = {
  small: 272,
  middle: 360,
  large: 440,
}

/** @deprecated Use `getGuideTourStepCardWidth('small')` or width map. */
export const GUIDE_TOUR_STEP_CARD_WIDTH =
  GUIDE_TOUR_STEP_CARD_WIDTH_BY_SIZE.small

const GUIDE_TOUR_STEP_CARD_ESTIMATED_HEIGHT_BY_SIZE: Record<
  GuideTourStepCardSize,
  number
> = {
  small: 224,
  middle: 248,
  large: 272,
}

export const getGuideTourStepCardWidth = (
  size: GuideTourStepCardSize = 'small'
): number => GUIDE_TOUR_STEP_CARD_WIDTH_BY_SIZE[size]

export const getGuideTourStepCardEstimatedHeight = (
  size: GuideTourStepCardSize = 'small'
): number => GUIDE_TOUR_STEP_CARD_ESTIMATED_HEIGHT_BY_SIZE[size]

export const resolveGuideTourStepCardSize = (
  step: Pick<GuideTourStep, 'size'> | null | undefined,
  tour?: Pick<GuideTourDefinition, 'size'> | null
): GuideTourStepCardSize => step?.size ?? tour?.size ?? 'small'
